<template>
	<div class="contact">
		<!-- 垫高 之后删掉 -->
		<div style="width: 100vw; height: 80px"></div>
		<div class="top_header">
			<img src="../../assets/images/contact_header.png" alt="" />
		</div>
		<RequireMent />
		<div class="body_map">
			<div class="header wow animate__fadeInDown animate__animated">
				<img src="../../assets/images/contact_map.png" alt="" />
				<div class="title">地图指引</div>
				<div class="blueline"></div>
			</div>
			<div id="container"></div>
		</div>
		<div class="body_contact">
			<div class="header wow animate__fadeInDown animate__animated">
				<img src="../../assets/images/contact_us.png" alt="" style="margin-top: 34px" />
				<div class="title">联系方式</div>
				<div class="blueline"></div>
			</div>
			<div class="contact_box">
				<div
					class="box shadow wow animate__fadeIn animate__animated"
					@click="handleJump"
					data-wow-delay="0.2s"
				>
					<div>
						<img src="../../assets/images/contact_home.png" alt="" />
					</div>
					<div class="title">公司</div>
					<div class="con">上海欧露塔科技有限公司</div>
				</div>
				<div
					class="box shadow wow animate__fadeIn animate__animated"
					@click="handleJump"
					data-wow-delay="0.2s"
				>
					<div>
						<img src="../../assets/images/contact_address.png" alt="" />
					</div>
					<div class="title">地址</div>
					<div class="con">上海市青浦区朱家角浦泰路368弄13、14号219室</div>
				</div>
				<div
					class="box shadow wow animate__fadeIn animate__animated"
					@click="handleJump"
					data-wow-delay="0.2s"
				>
					<div>
						<img src="../../assets/images/contact_email.png" alt="" />
					</div>
					<div class="title">邮箱</div>
					<div class="con">support@omishow.cn</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { onMounted, reactive, ref } from "vue";
import WOW from "wow.js";
import AMapLoader from "@amap/amap-jsapi-loader";
import { useRouter } from "vue-router";
const router = useRouter();
const importScript = () => {
	window._AMapSecurityConfig = {
		securityJsCode: "9f6d4a0656cbdf3309c165727ddf1fea",
	};
	// const script = document.createElement("script");
	// script.type = "text/javascript";
	// script.src = "https://webapi.amap.com/loader.js";
	// script.async = true;
	// document.getElementsByTagName("body")[0].appendChild(script);
	// script.onload = () => {

	// };
	AMapLoader.load({
		key: "4349e7900b927623057154a60cc3202b", //申请好的Web端开发者Key，首次调用 load 时必填
		version: "2.0", //指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
	})
		.then((AMap) => {
			const map = new AMap.Map("container", {
				zoom: 18, // 初始化地图级别
				center: [121.0426705, 31.1417307],
			});
			AMap.plugin(
				["AMap.ToolBar", "AMap.Scale", "AMap.HawkEye", "AMap.MapType", "AMap.Geolocation"],
				function () {
					// 在图面添加工具条控件，工具条控件集成了缩放、平移、定位等功能按钮在内的组合控件
					map.addControl(
						new AMap.ToolBar({
							position: {
								top: "10px",
								left: "20px",
							},
						})
					);
					// 在图面添加比例尺控件，展示地图在当前层级和纬度下的比例尺
					map.addControl(new AMap.Scale());

					// 在图面添加鹰眼控件，在地图右下角显示地图的缩略图
					map.addControl(new AMap.HawkEye({ isOpen: true }));

					// 在图面添加类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
					map.addControl(new AMap.MapType());

					// 在图面添加定位控件，用来获取和展示用户主机所在的经纬度位置
					map.addControl(new AMap.Geolocation());
				}
			);
			const infoWindow = new AMap.InfoWindow({
				//创建信息窗体
				isCustom: true, //使用自定义窗体
				content:
					"<div style='background:white;padding:5px;border-radius:5px;'>上海欧露塔科技有限公司</div>", //信息窗体的内容可以是任意html片段
				offset: new AMap.Pixel(16, -45),
			});
			const onMarkerClick = function (e) {
				infoWindow.open(map, e.target.getPosition()); //打开信息窗体
				//e.target就是被点击的Marker
			};
			const marker = new AMap.Marker({
				position: [121.378874, 31.106167],
			});
			map.add(marker);
			marker.on("click", onMarkerClick);
		})
		.catch((e) => {
			console.error(e); //加载错误提示
		});
};
const wowjsFn = () => {
	let wow = new WOW({
		boxClass: "wow", // default
		animateClass: "animate__animated", // default
		offset: 0, // default
		mobile: true, // default
		live: true, // default
	});
	wow.init();
};
const handleJump = () => {
	window.scrollTo(0, 0);
	router.push("/service");
};
onMounted(() => {
	wowjsFn();
	importScript();
});
</script>

<style lang="less" scoped>
.contact {
	overflow-x: hidden;
	.top_header {
		width: 100vw;
		height: 240px;
		background-image: url("../../assets/images/bnnderBG.png");
		background-repeat: no-repeat;
		background-size: cover;
		display: flex;
		align-items: center;
		justify-content: center;
		img {
			width: 1287px;
			height: 240px;
		}
	}
	.body_map {
		width: 100vw;
		display: flex;
		flex-direction: column;
		align-items: center;
		background-image: url("../../assets/images/contact_three.png");
		background-repeat: no-repeat;
		background-size: contain;
		#container {
			margin-top: 20px;
			margin-bottom: 80px;
			max-width: 1064px;
			width: 95%;
			height: 384px;
			overflow: hidden;
		}
	}
	.body_contact {
		width: 100vw;
		display: flex;
		flex-direction: column;
		align-items: center;
		background-image: url("../../assets/images/requirement_part_back.png");
		background-repeat: no-repeat;
		background-size: cover;
	}
	.header {
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 20px;
		color: #102d4d;
		letter-spacing: 1.5px;
		font-weight: bold;
		position: relative;
		img {
			margin-top: 21px;
			transform: scale(0.75);
		}
		.title {
			margin-top: -20px;
		}
		.blueline {
			width: 44px;
			height: 4px;
			background: #12b1f9;
			margin: 20px 0px;
		}
	}
}
@media screen and (min-width: 600px) {
	.contact_box {
		display: flex;
		align-items: center;
		width: 100%;
		justify-content: space-around;
		max-width: 1100px;
		margin-top: 45px;
		margin-bottom: 87px;
		.box {
			cursor: pointer;
			margin: 0px 5px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			border-radius: 12px;
			border-right: 1px solid #eee;
			border-top: 1px solid #eee;
			border-bottom: 1px solid #eee;
			border-left: 1px solid #eee;
			border-radius: 12px;
			background-color: #fff;
			max-width: 280px;
			min-width: 180px;
			width: 100%;
			height: 208px;
			box-shadow: 0 0 0 rgba(18, 177, 249, 0.44);
			.title {
				font-weight: bold;
				color: #102d4d;
				font-size: 18px;
				margin-top: 20px;
			}
			.con {
				line-height: 1.5;
				color: #58687b;
				font-size: 14px;
				margin-top: 20px;
				padding: 0px 10px;
				text-align: center;
			}
		}
		.shadow {
			transition: all 0.3s;
		}
		.shadow:hover {
			box-shadow: 0px 15px 30px rgba(15, 144, 204, 0.24);
			transition: all 0.3s;
			transform: translateY(-5px);
		}
	}
}
@media screen and (max-width: 599px) and (min-width: 400px) {
	.contact_box {
		display: flex;
		align-items: center;
		width: 100%;
		justify-content: flex-start;
		flex-wrap: wrap;
		margin-top: 35px;
		margin-bottom: 87px;
		.box {
			cursor: pointer;
			margin-left: 10px;
			margin-top: 10px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			border-radius: 12px;
			border-right: 1px solid #eee;
			border-top: 1px solid #eee;
			border-bottom: 1px solid #eee;
			border-left: 1px solid #eee;
			border-radius: 12px;
			background-color: #fff;
			width: calc(50% - 15px);
			height: 208px;
			.title {
				font-weight: bold;
				color: #102d4d;
				font-size: 18px;
				margin-top: 20px;
			}
			.con {
				line-height: 1.5;
				color: #58687b;
				font-size: 14px;
				margin-top: 20px;
				padding: 0px 10px;
				text-align: center;
			}
		}
		.shadow {
			// transition: all 0.3s;
		}
		.shadow:hover {
			box-shadow: 0px 15px 30px rgba(15, 144, 204, 0.24);
			transition: all 0.3s;
			transform: translateY(-5px);
		}
	}
}
@media screen and (max-width: 400px) {
	.contact_box {
		display: flex;
		align-items: center;
		width: 100%;
		justify-content: flex-start;
		flex-wrap: wrap;
		margin-top: 35px;
		margin-bottom: 87px;
		.box {
			cursor: pointer;
			margin-left: 10px;
			margin-top: 10px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			border-radius: 12px;
			border-right: 1px solid #eee;
			border-top: 1px solid #eee;
			border-bottom: 1px solid #eee;
			border-left: 1px solid #eee;
			border-radius: 12px;
			background-color: #fff;
			width: calc(100% - 20px);
			height: 208px;
			.title {
				font-weight: bold;
				color: #102d4d;
				font-size: 18px;
				margin-top: 20px;
			}
			.con {
				line-height: 1.5;
				color: #58687b;
				font-size: 14px;
				margin-top: 20px;
				padding: 0px 10px;
				text-align: center;
			}
		}
		.shadow {
			transition: all 0.3s;
		}
		.shadow:hover {
			box-shadow: 0px 15px 30px rgba(15, 144, 204, 0.24);
			transition: all 0.3s;
			transform: translateY(-5px);
		}
	}
}
</style>
